import { GET_PICKUP_LOCATION, GetRequest, GetResultObject } from "../../../utils/API";

const TYPES = {
  UPDATE_DRIVER_LIVE_LOCATION: "UPDATE_DRIVER_LIVE_LOCATION",
  UPDATE_DRIVER_LIVE_LOCATION_LIST: "UPDATE_DRIVER_LIVE_LOCATION_LIST",

  GET_PICKUP_LOCATION_SUCCESS : "GET_PICKUP_LOCATION_SUCCESS"
};


const updateDriverLocationList = (payload) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.UPDATE_DRIVER_LIVE_LOCATION_LIST,
      payload: payload,
    });
  }
}

const updateDriverLocation = (driver) => {
  return (dispatch) => {
    // console.log("driver state.driver", driver)
    dispatch({
      type: TYPES.UPDATE_DRIVER_LIVE_LOCATION,
      payload: {driver},
    });
  }
}


// pickup location
const getPickupLocation = () => {
  return (dispatch) => {
    GetRequest(GET_PICKUP_LOCATION, {}).then(result=> {

      GetResultObject(result, 'data', 200, (datas) => {
        dispatch({
          type: TYPES.GET_PICKUP_LOCATION_SUCCESS,
          payload: datas,
        });
      })
    })
  };
}

export default {
  updateDriverLocation,
  updateDriverLocationList,
  getPickupLocation,
  TYPES,
};
